import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Bullet} from 'components/ui';
import {StepTypeTexts} from 'utils/types/learningPath';
import styles from './StepBullet.module.scss';

export type StepStatus =
  | 'expired'
  | 'finished'
  | 'inReview'
  | 'available'
  | 'inProgress'
  | 'scheduled'
  | '';

export interface StepBulletProps {
  order: number;
  onClick?(): void;
  type: 'write' | 'questionnaire' | 'pedagogical content' | 'rewrite';
  status: StepStatus;
  isOlympics?: boolean;
  captionOverride?: string;
}

function StepBullet({
  status,
  order,
  type,
  onClick,
  isOlympics = false,
  captionOverride,
}: StepBulletProps): JSX.Element {
  const hasIcon = status === 'finished' || status === 'inReview';

  const STATUS_ICONS: Record<string, IconProp> = {
    finished: 'check',
    inReview: ['fad', 'hourglass-start'],
  };

  const STATUS_TEXTS = {
    expired: 'Expirado',
    finished: type === 'write' ? 'Corrigido' : 'Concluído',
    inReview: 'Corrigindo',
    available: 'Disponível',
    inProgress: 'Andamento',
    scheduled: '',
  };

  function handleBulletClick() {
    if (status !== 'expired' && status !== 'scheduled') {
      onClick?.();
    }
  }

  const caption =
    captionOverride ??
    (isOlympics && type === 'pedagogical content'
      ? 'Um Mundo a Dizer'
      : `${StepTypeTexts[type]} ${STATUS_TEXTS[status] ?? ''}`);

  return (
    <>
      <Bullet
        order={order}
        onClick={handleBulletClick}
        className={`${styles[status]} ${styles.bullet}`}
        caption={caption}
      >
        {hasIcon ? (
          <FontAwesomeIcon icon={STATUS_ICONS[status]} size="sm" />
        ) : (
          order
        )}
      </Bullet>
      <hr className={styles.stepSeparator} />
    </>
  );
}

export default StepBullet;
